module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-margin order-div"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.JobType), function(jt, index) {
    return _c('div', {
      key: index,
      staticClass: "center",
      class: {
        'col-sm-4': _vm.JobType.length == 3, 'col-sm-6': _vm.JobType.length == 2
      }
    }, [_c('label', {
      staticClass: "g-font-size-20"
    }, [_vm._v(_vm._s(jt.description))]), _vm._v(" "), _c('div', {
      staticClass: "image-div",
      on: {
        "click": function($event) {
          return _vm.CheckVal(jt.type)
        }
      }
    }, [(_vm.Order.JobType != jt.type) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": jt.imageURL
      }
    }) : _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": jt.invertedImageURL
      }
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Order.JobType),
        expression: "Order.JobType"
      }],
      attrs: {
        "type": "radio",
        "name": "frameJobtype"
      },
      domProps: {
        "value": jt.type,
        "checked": _vm._q(_vm.Order.JobType, jt.type)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.Order, "JobType", jt.type)
        }, function($event) {
          return _vm.CheckVal(jt.type)
        }]
      }
    })])
  }), _vm._v(" "), (_vm.ValidationResult.OrderJobType) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.ValidationResult.OrderJobType) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderJobType))]) : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), ((_vm.Order.JobType == 'FTC') || (_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('p', [_vm._v("Please enter as much information as possible to assist the lab in correctly identifying the frame.")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Manufacturer")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameManufacturer),
      expression: "Order.FrameManufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. FGX"
    },
    domProps: {
      "value": (_vm.Order.FrameManufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameManufacturer", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Brand")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameBrand),
      expression: "Order.FrameBrand"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. Lantis"
    },
    domProps: {
      "value": (_vm.Order.FrameBrand)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameBrand", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Model")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameModel),
      expression: "Order.FrameModel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "i.e. Sidekick, L00015, or Strike/L00132"
    },
    domProps: {
      "value": (_vm.Order.FrameModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameModel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Frame Type"), ((_vm.Order.JobType == 'FTC')) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameType),
      expression: "Order.FrameType"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameType
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Order, "FrameType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.FrameType), function(ft) {
    return _c('option', {
      domProps: {
        "value": ft.code
      }
    }, [_vm._v(_vm._s(ft.name))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderFrameType) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameType))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameColor),
      expression: "Order.FrameColor"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameColor
    },
    attrs: {
      "type": "text",
      "placeholder": "i.e. Tortoise, Red"
    },
    domProps: {
      "value": (_vm.Order.FrameColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameColor", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameColor) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameColor))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Eye Size"), (((_vm.Order.JobType == 'FTC' || _vm.Order.JobType == 'UNC') && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "small",
      "font-weight": "normal"
    }
  }, [_vm._v("(A-box)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameEyeSize),
      expression: "Order.FrameEyeSize"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameEyeSize
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 50"
    },
    domProps: {
      "value": (_vm.Order.FrameEyeSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameEyeSize", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameEyeSize) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameEyeSize))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("DBL"), (((_vm.Order.JobType == 'UNC' || _vm.Order.JobType == 'FTC') && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameDBL),
      expression: "Order.FrameDBL"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameDBL
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 15"
    },
    domProps: {
      "value": (_vm.Order.FrameDBL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameDBL", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameDBL) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameDBL))]) : _vm._e()])]), _vm._v(" "), ((_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("B-Box"), ((_vm.Order.JobType == 'UNC' && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameBBox),
      expression: "Order.FrameBBox"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameBBox
    },
    attrs: {
      "type": "number",
      "max": "30",
      "placeholder": "i.e. 25"
    },
    domProps: {
      "value": (_vm.Order.FrameBBox)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameBBox", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameBBox) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameBBox))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.Order.JobType == 'UNC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left input-space-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("ED"), ((_vm.Order.JobType == 'UNC' && !_vm.Order.FrameCheckMeasurements)) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameED),
      expression: "Order.FrameED"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderFrameED
    },
    attrs: {
      "type": "number",
      "placeholder": "i.e. 50"
    },
    domProps: {
      "value": (_vm.Order.FrameED)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameED", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderFrameED) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameED))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.Order.JobType == 'FTC')) ? _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 input-space-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "login_info_label"
  }, [_vm._v("Temple Length")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameTempleLength),
      expression: "Order.FrameTempleLength"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "i.e. 140"
    },
    domProps: {
      "value": (_vm.Order.FrameTempleLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "FrameTempleLength", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12"
  }), _vm._v(" "), (!_vm.Order.IsExamOnly) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Frame Measurements:\n                  "), _c('span', {
    attrs: {
      "data-balloon": "Click this button to view how to find your measurements",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.ShowFrameSizeModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.FrameCheckMeasurements),
      expression: "Order.FrameCheckMeasurements"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.Order.FrameCheckMeasurements,
      "checked": Array.isArray(_vm.Order.FrameCheckMeasurements) ? _vm._i(_vm.Order.FrameCheckMeasurements, _vm.Order.FrameCheckMeasurements) > -1 : (_vm.Order.FrameCheckMeasurements)
    },
    on: {
      "click": function($event) {
        return _vm.ClickNoFrameMeasurements()
      },
      "change": function($event) {
        var $$a = _vm.Order.FrameCheckMeasurements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.Order.FrameCheckMeasurements,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "FrameCheckMeasurements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "FrameCheckMeasurements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "FrameCheckMeasurements", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_vm._v("I dont have frame measurements (may result in thicker lens)")])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.JobType == 'LSF' && (this.framePageVisible == 'true' || _vm.MasterAccountType == 'master')) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group order-div order-div"
  }, [_c('label', [_vm._v("Select Your Frame*")]), _vm._v(" "), _c('multiselect', {
    class: {
      error_select: _vm.ValidationResult.OrderFrameId
    },
    attrs: {
      "custom-label": _vm.customLabel,
      "options": _vm.FrameAndLens,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "input": function($event) {
        return _vm.FrameAndLensValue(false)
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', [_vm._v("Name/Model: " + _vm._s(props.option.name) + " - Color: " + _vm._s(props.option.color) + " - Eyesize: " + _vm._s(props.option.eyeSize) + " - Frame Type: " + _vm._s(props.option.frameType) + "  " + _vm._s(props.option.catalogId ? '- Catalog -' + _vm.ConvertToTitleCase(props.option.catalogId) : ''))]), _vm._v(" "), _c('span', {
          staticClass: "pull-right stock-text"
        }, [(props.option.isOutOfStock || props.option.isLowStock) ? _c('span', [_vm._v("Low Stock")]) : _vm._e()])]
      }
    }], null, false, 1012384014),
    model: {
      value: (_vm.CurrentFrameAndLens),
      callback: function($$v) {
        _vm.CurrentFrameAndLens = $$v
      },
      expression: "CurrentFrameAndLens"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderFrameId) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderFrameId))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.CurrentFrameAndLens) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-11 col-md-11 col-sm-12 col-xs-12 v-"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "image-div-frame"
  }, [_c('img', {
    staticClass: "img-fluid image-icon",
    attrs: {
      "src": _vm.CurrentFrameAndLens.frontImageURL
    },
    on: {
      "error": function($event) {
        return _vm.ImageExists(_vm.CurrentFrameAndLens)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Model Name/#: " + _vm._s(_vm.CurrentFrameAndLens.name))]), _vm._v(" "), _c('p', [_vm._v("Color: " + _vm._s(_vm.CurrentFrameAndLens.color))]), _vm._v(" "), _c('p', [_vm._v("Measurements: " + _vm._s(_vm.CurrentFrameAndLens.eyeSize) + " - " + _vm._s(_vm.CurrentFrameAndLens.dbl) + " - " + _vm._s(_vm.CurrentFrameAndLens.templeLength))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-5 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("Frame Type: " + _vm._s(_vm.CurrentFrameAndLens.frameType))]), _vm._v(" "), _c('p', [_vm._v("Manufacturer: " + _vm._s(_vm.CurrentFrameAndLens.manufacturer))]), _vm._v(" "), _c('p', [_vm._v("Brand: " + _vm._s(_vm.CurrentFrameAndLens.frameBrand))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(((_vm.Capping.frameLensCap - _vm.Capping.frameLensCount) <= _vm.Capping.frameLensThreshold) && (_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn) ? _c('p', {
    staticClass: "warning-text-color"
  }, [_vm._v("\n                    You have " + _vm._s(_vm.Capping.frameLensCap - _vm.Capping.frameLensCount) + " frame & lens orders remaining on your account. After that number is reached you will no longer be able to place frame & lens orders. For more information,\n                    "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.OpenHelpForm()
      }
    }
  }, [_vm._v("contact us.")])]) : _vm._e(), _vm._v(" "), ((_vm.Capping.frameLensCount >= _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n                    You have reached your Frame and Lens limit and are no longer able to submit these orders. For more information,\n                    "), _c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        return _vm.OpenHelpForm()
      }
    }
  }, [_vm._v("contact us.")])]) : _vm._e(), _vm._v(" "), ((_vm.Capping.frameLensCount < _vm.Capping.frameLensCap) && (_vm.MasterAccountType != 'master') && _vm.Capping.isFrameLensCapOn && _vm.isFrameLensServiceFee) ? _c('p', {
    staticClass: "lsf-payment"
  }, [_c('b', [_vm._v("Please Note:")]), _vm._v(" After you submit, you will be charged a service fee for this order.\n                ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseOOSModal()
      }
    }
  }), _vm._v(" "), (_vm.isFormLoading) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "g-mt-20 g-mx-20"
  }, [(_vm.suggestedFrameList.length == 0) ? _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Out of Stock")]), _vm._v(" "), _c('p', [_vm._v("Sorry, this frame is out of stock. Please select another.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.CloseOOSModal()
      }
    }
  }, [_vm._v("Close")])])])])]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.suggestedFrameList), function(frame, key) {
    return _c('div', {
      key: key,
      staticClass: "col-lg-3 g-mb-30 g-py-5"
    }, [_c('article', [_c('div', {
      staticClass: "gray-border"
    }, [(frame.imageUrl != null || frame.imageUrl != 'NULL') ? _c('div', {
      staticClass: "location_img swiper-slide"
    }, [_c('div', {
      staticClass: "frame-pic-div",
      staticStyle: {
        "height": "150px"
      }
    }, [_c('img', {
      staticClass: "img-fluid image-align-vert-hor",
      attrs: {
        "src": frame.frontImageURL,
        "alt": "Image Description"
      },
      on: {
        "error": function($event) {
          return _vm.ImageExists(frame)
        }
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "g-pa-15 gray-border"
    }, [_c('label', {
      staticClass: "g-font-weight-600 frame-label"
    }, [_vm._v("Name:")]), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.name))]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 mb-1 frame-label"
    }, [_vm._v("Color: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(frame.color))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Frame Type: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameType) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Measurements: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "frame-description"
    }, [_vm._v(_vm._s(frame.eyeSize) + " - " + _vm._s(frame.dbl) + " - " + _vm._s(frame.templeLength))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "g-pa-15 gray-border"
    }, [_c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Manufacturer: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.manufacturer) + " ")]), _c('br'), _vm._v(" "), _c('label', {
      staticClass: "g-color-text g-font-weight-500 frame-label mb-1"
    }, [_vm._v("Brand: ")]), _vm._v(" "), _c('span', {
      staticClass: "g-color-text frame-description mb-1"
    }, [_vm._v(_vm._s(frame.frameBrand) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
      on: {
        "click": function($event) {
          return _vm.SelectFrameSuggestion(frame)
        }
      }
    }, [_vm._v("SELECT")])])])])
  })], 2)])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isFrameSizeModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseFrameSizeModal()
      }
    }
  }), _vm._v(" "), (_vm.isFormLoading) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('page-loader')], 1) : _c('div', {
    staticClass: "g-mt-20 g-mx-20"
  }, [_c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h4', [_vm._v("How to find frame measurements")]), _vm._v(" "), _c('p', [_vm._v("Providing accurate frame measurements helps the lab determine the best lens for the frame. Most frames will have the measurements printed inside one of the temples. You may also use a PD Ruler to collect the measurements yourself.If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("You may also use PDP Ruler to collect the measurement your self")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("If you are not able to provide these measurements, we will select default values for you but this may result in a thicker lens.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.CloseFrameSizeModal()
      }
    }
  }, [_vm._v("Close")])])])])])])])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n            Frame Information\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', [_vm._v("\n                    Please select the order type from the icons below.*\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Out of Stock")]), _vm._v(" "), _c('p', [_vm._v("Sorry, the frame you selected is no longer available. Please select another frame from below, or click the X to return to the order.")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "max-width": "750px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../../../../../static/assets/img/FamilyImages/temple-size.png"),
      "alt": "Temple size"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "max-width": "750px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../../../../../static/assets/img/FamilyImages/frame-measurement.png"),
      "alt": "Frame Measurement"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fca6f02", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fca6f02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/FrameInformation.vue
// module id = 530
// module chunks = 4